import { connect } from "react-redux";

import {
    reloadForm,
    uploadFileAction,
    uploadFufFileAction,
    importXmlsAction,
    combineMultipleFufWithTransferType,
    UploadedRSVFileInfo,
} from "../../../../ActionCreators/FufUploadActionCreator";
import { CandyDispatch } from "../../../Store/CandyReduxTypes";
import { CustomFile } from "../../../../../Helpers/file";
import { FullFormState } from "../../../Store/FullFormState";
import {
    CombinatorType,
    CombineFufResult,
    FufCombineMethod,
} from "../../../../../../../Common/CandyApiClient/Types/DraftActions/CombineFufResult";
import { ServerErrorResponse } from "../../../../../../../Common/CandyApiClient/Types/DraftActions/FileProperties";
import { ICombineByTransfers } from "../UploadSection/Types";

import { UploadXmlInTable } from "./UploadXmlInTable";

const mapStateToProps = (state: FullFormState) => ({
    currentGfv: state.settings.gfv,
    modalSettings: state.modalState,
});

const mapDispatchToProps = (dispatch: CandyDispatch) => ({
    getFileProperties: (file: CustomFile | undefined): Promise<UploadedRSVFileInfo> =>
        dispatch(uploadFufFileAction(file)),
    uploadFile: (): Promise<CustomFile | undefined> => dispatch(uploadFileAction),
    importXmls: (
        driveUris: string[],
        combineMethod: FufCombineMethod,
        combinatorType: CombinatorType,
        isImportByFuf: boolean,
        args?: string[]
    ): Promise<CombineFufResult | undefined> =>
        dispatch(importXmlsAction(driveUris, combineMethod, combinatorType, isImportByFuf, args)),
    reloadForm: (path?: string): void => reloadForm(path),
    combineMultipleWithTransfer: (
        files: ICombineByTransfers[],
        abortSignal?: AbortSignal
    ): Promise<ServerErrorResponse | undefined> => dispatch(combineMultipleFufWithTransferType(files, abortSignal)),
});

export const UploadXmlInTableContainer = connect(mapStateToProps, mapDispatchToProps)(UploadXmlInTable);
